// Sprint UXV UXV.F4 (#1420) — effective Claude Design export toggle.
//
// Inheritance model (mirrors estimation_type, NOT delivery_mode — see
// Sprint-Artefacts/uxv-f4-recon.md §0b): a tenant-level boolean default plus a
// per-project NULLABLE override. The project override wins iff it is an
// explicit boolean; otherwise the project inherits the tenant default.
//
// Fail-CLOSED: anything that is not unambiguously ON resolves to `false`. A
// missing / null / undefined tenant default — a row read by a code path that
// did not select the column, a pre-migration row, or a stale client — never
// surfaces the export action. The `=== true` coercion is the fail-closed seam.
//
// SINGLE SOURCE OF TRUTH: imported by the API and by F2's export-action gate so
// there is exactly one effective-value computation. Do NOT re-derive
// `override ?? tenant` anywhere else.

/**
 * Resolve the effective Claude Design export toggle for a project.
 *
 * @param projectOverride per-project override (`projects.claude_design_export_enabled`);
 *   `null`/`undefined` = inherit the tenant default.
 * @param tenantDefault tenant default (`tenants.claude_design_export_enabled`).
 * @returns `true` only when unambiguously enabled; fail-closed `false` otherwise.
 */
export function getEffectiveClaudeDesignExportEnabled(
  projectOverride: boolean | null | undefined,
  tenantDefault: boolean | null | undefined,
): boolean {
  if (typeof projectOverride === 'boolean') return projectOverride;
  return tenantDefault === true;
}
